import React from "react";
import {KeyboardDatePicker} from "@material-ui/pickers";
import PropTypes from "prop-types";

/**
 * Komponente zur Abfrage eines Datums
 * @param id
 * @param value Datum im Format dd.MM.yyyy
 * @param onChange(date) Wird mit dem Format (yyyy-MM-dd) aufgerufen.
 * @param label
 * @param error Fehlermeldung, falls vorhanden
 * @param className
 * @param rest u.A.:
 * <ul>
 *     <li>disableFuture</li>
 *     <li>disablePast</li>
 *     </ul>
 * @returns {JSX.Element}
 * @constructor
 */
function EADatePicker({id, value, onChange, label, error, className, ...rest}) {
    const classes = className ? className + " ea-dp" : "ea-dp";
    return (
        <KeyboardDatePicker
            autoOk
            InputAdornmentProps={{autoComplete: "new-password"}}
            onChange={(date) => {
                onChange(date);
            }}
            value={value ? value : null}
            className={classes}
            variant="inline"
            inputVariant="outlined"
            format="dd.MM.yyyy"
            invalidDateMessage="Ungültiges Datumsformat"
            helperText={error}
            id={id}
            label={label}
            KeyboardButtonProps={{
                "aria-label": "Datum ändern",
            }}
            error={error && true}
            {...rest}
        />
    );
}

EADatePicker.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
};

export default EADatePicker;
